import { render, staticRenderFns } from "./MainInformation.vue?vue&type=template&id=7831d642&scoped=true&"
import script from "./MainInformation.vue?vue&type=script&lang=js&"
export * from "./MainInformation.vue?vue&type=script&lang=js&"
import style0 from "./MainInformation.vue?vue&type=style&index=0&id=7831d642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7831d642",
  null
  
)

export default component.exports